
import * as defaultImport from "@splunk/react-docs/API";
export * from "@splunk/react-docs/API";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
